import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CellCloseEvent } from '@progress/kendo-angular-grid/dist/es2015/editing/cell-close-event';
import { takeUntil } from 'rxjs/operators';
import { FormComponentBase } from 'src/app/common/form-component-base';
import { Global } from 'src/app/common/global';
import { ILanguage, ITimeEntryType, ITimeEntryTypeTranslation } from 'src/app/services/api/api-model';
import { DataService } from 'src/app/services/api/data.service';
import { StaticDataService } from 'src/app/services/api/static-data.service';
import { SessionService } from 'src/app/services/session/session.service';

@Component({
  selector: 'app-time-entry-type-translation-dialog',
  templateUrl: './time-entry-type-translation-dialog.component.html'
})
export class TimeEntryTypeTranslationDialogComponent extends FormComponentBase implements OnInit {
  @Input() public timeEntryType: ITimeEntryType;

  public visibleValue = false;
  @Input()
  get visible(): boolean {
    return this.visibleValue;
  }
  set visible(value: boolean) {
    if (this.visibleValue !== value) {
      this.visibleValue = value;
      this.visibleChange.emit(value);
      if (value) {
        this.prepareTranslationData(this.timeEntryType);
      }
    }
  }
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() public translateComplete: EventEmitter<any> = new EventEmitter<any>();

  public gridData: ITimeEntryTypeTranslation[] = [];
  public languages: ILanguage[];
  private inheritClass = 'grid-inherit-cell';
  public triggerUpdate: boolean;

  constructor(
    private dataService: DataService,
    private sessionService: SessionService,
    private staticDataService: StaticDataService
  ) {
    super();
    this.childIsDirty = Array(1).fill(false);
  }

  public ngOnInit(): void {
    this.staticDataService.languages.pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: ILanguage[]) => {
      this.languages = data;
    });
  }
  public get IsReadOnly(): boolean {
    return this.sessionService.role.IsReadOnly;
  }

  public onDialogAction(action: string): void {
    if (action === 'Update') {
      this.updateTimeEntryTypeTranslation();
    }
  }

  public onSaveChange(value: CellCloseEvent): void {
    this.childIsDirty[0] = true;
  }

  private prepareTranslationData(timeEntry: any): void {
    this.gridData = [];
    if (!timeEntry) {
      return;
    }

    this.dataService.TimeEntryTypes_GetTranslations(timeEntry.Id).subscribe((data: ITimeEntryTypeTranslation[]) => {
      this.gridData = data;
    });
  }

  private getFieldTranslation(fieldName: string): string {
    let translationText: string;
    if (
      this.timeEntryType &&
      this.timeEntryType.TimeEntryTypeTranslations &&
      this.timeEntryType.TimeEntryTypeTranslations.length > 0
    ) {
      const translation: any = this.timeEntryType.TimeEntryTypeTranslations.find(
        (t: ITimeEntryTypeTranslation) => t.LanguageId === Global.SESSION.SignOnToken.LanguageId
      );
      translationText = translation ? translation[fieldName] : undefined;
    }

    return translationText;
  }

  private getBaseTranslation(fieldName: string, languageId?: number): string {
    if (!this.timeEntryType || !this.timeEntryType.BaseTimeEntryType) {
      return undefined;
    }

    let translationText: string;
    if (
      this.timeEntryType.BaseTimeEntryType.TimeEntryTypeTranslations &&
      this.timeEntryType.BaseTimeEntryType.TimeEntryTypeTranslations.length > 0
    ) {
      const translation: any = this.timeEntryType.BaseTimeEntryType.TimeEntryTypeTranslations.find(
        (t: ITimeEntryTypeTranslation) => t.LanguageId === languageId
      );
      translationText = translation ? translation[fieldName] : undefined;
    }

    return translationText ? translationText : (this.timeEntryType.BaseTimeEntryType as any)[fieldName];
  }

  private updateTimeEntryTypeTranslation(): void {
    if (!this.gridData) {
      return;
    }

    this.dataService.TimeEntryTypes_SetTranslations(this.gridData).subscribe((data: ITimeEntryTypeTranslation[]) => {
      this.translateComplete.emit(data);
      this.gridData = data;
      this.visible = false;
    });
  }
}
